/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'basic/no-message-1218395': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M10.19 5.23A7.12 7.12 0 0112 5a7 7 0 017 7 7.12 7.12 0 01-.23 1.81 1 1 0 00.7 1.23 1.15 1.15 0 00.26 0 1 1 0 001-.74A8.91 8.91 0 0021 12a9 9 0 00-9-9 8.91 8.91 0 00-2.33.3A1 1 0 009 4.53a1 1 0 001.19.7zm11.52 15.06l-18-18a1 1 0 00-1.42 1.42L5 6.38a9 9 0 000 11.24l-1.71 1.67a1 1 0 00-.21 1.09A1 1 0 004 21h8a9 9 0 005.62-2l2.67 2.68a1 1 0 001.42 0 1 1 0 000-1.39zM12 19H6.41l.64-.63a1 1 0 000-1.41 7 7 0 01-.65-9.15l9.79 9.79A7 7 0 0112 19z"/>'
  }
})
